import React, { useState } from "react";
import { Box } from "theme-ui";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "components/ui/Modal";
import BasicButton from "components/forms/BasicButton";
import SelectInput from "components/forms/SelectInput";
import TextInput from "components/forms/TextInput";
import { themevals } from "theme/themevals";

const PAYMENT_METHODS = [
  { value: "", label: "Select method..." },
  { value: "check", label: "Check" },
  { value: "ach_direct", label: "ACH (Direct)" },
  { value: "wire", label: "Wire Transfer" },
  { value: "stripe_card", label: "Stripe - Card" },
  { value: "stripe_ach", label: "Stripe - ACH" },
  { value: "other", label: "Other" },
];

interface RecordDepositModalProps {
  quote: any;
  onConfirm: (data: { method: string; amount?: number; referenceId?: string; note?: string }) => void;
  onCancel: () => void;
  submitting: boolean;
}

const RecordDepositModal: React.FC<RecordDepositModalProps> = ({ quote, onConfirm, onCancel, submitting }) => {
  const [method, setMethod] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [amount, setAmount] = useState(String(quote.priceLockDepositAmount || ""));
  const [note, setNote] = useState("");

  const handleSubmit = () => {
    if (!method) return;
    const data: any = { method };
    if (amount && parseFloat(amount) > 0) data.amount = parseFloat(amount);
    if (referenceId.trim()) data.referenceId = referenceId.trim();
    if (note.trim()) data.note = note.trim();
    onConfirm(data);
  };

  const fmtCurrency = (v: number) => "$" + v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <Modal isOpen={true} toggle={onCancel} size="md" centered={true}>
      <ModalHeader toggle={onCancel}>
        <Box sx={{ fontFamily: "Rubik", fontSize: "16px", fontWeight: 500, color: themevals.colors.black }}>
          Record Deposit
        </Box>
        <Box sx={{ fontFamily: "Poppins", fontSize: "12px", color: themevals.colors.dkgrey, marginTop: "2px" }}>
          Record a deposit payment received for this price lock.
        </Box>
      </ModalHeader>
      <ModalBody>
        <div style={{ backgroundColor: "#F7FAFC", border: "1px solid #E2E8F0", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontFamily: "Poppins, sans-serif" }}>
            <span style={{ fontSize: "13px", color: themevals.colors.dkgrey }}>Expected Deposit</span>
            <span style={{ fontSize: "14px", fontWeight: 600, color: themevals.colors.black }}>{fmtCurrency(quote.priceLockDepositAmount || 0)}</span>
          </div>
        </div>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <SelectInput
            label="Payment Method"
            name="method"
            value={method}
            onChange={(val: any) => setMethod(val || "")}
            options={PAYMENT_METHODS}
          />
          <TextInput
            label="Reference ID"
            value={referenceId}
            onChange={(val: any) => setReferenceId(val || "")}
            placeholder="Check #, transaction ref, etc."
          />
          <TextInput
            label="Amount Received"
            value={amount}
            onChange={(val: any) => setAmount(val || "")}
            placeholder="Deposit amount"
          />
          <TextInput
            label="Notes (optional)"
            value={note}
            onChange={(val: any) => setNote(val || "")}
            placeholder="Any additional details..."
          />
        </Box>
      </ModalBody>
      <ModalFooter>
        <BasicButton scheme="secondary" outline={true} styles={{ margin: "0 10px .25rem 0" }} type="button" onClick={onCancel}>Cancel</BasicButton>
        <BasicButton
          scheme="primary"
          styles={{ margin: "0" }}
          type="button"
          onClick={handleSubmit}
          $submitting={submitting}
          $loadingColor="#fff"
          keepText={true}
        >
          Record Deposit
        </BasicButton>
      </ModalFooter>
    </Modal>
  );
};

export default RecordDepositModal;
